const gridNames = {
  auctions: 'auctions',
  observedAuctions: 'observedAuctions',
  transportOrders: 'transportOrders',
  drivers: 'drivers',
  cars: 'cars',
};

export default gridNames;
